import 'react-notifications-component/dist/theme.css';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './redux/store';
import { Provider } from 'react-redux';
import ReactNotification from "react-notifications-component";
import { BrowserRouter as Router } from "react-router-dom";
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';  // Đảm bảo rằng i18n đã được cấu hình đúng
import { SnackbarProvider } from 'notistack';
ReactDOM.render(

	<Provider store={store}>
		<React.StrictMode>
			<I18nextProvider i18n={i18n}>
				<SnackbarProvider maxSnack={3}
				classes={{
					containerRoot: 'middle',
				}}>
					<Router>
						<App />
					</Router>
				</SnackbarProvider>
			</I18nextProvider>
		</React.StrictMode>
	</Provider >,

	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
